import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import Bus from '@/utils/bus';
export default {
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      active: 0,
      // 当前激活
      cur: '2',
      // 当前选中的语言
      index: 0,
      // 当前选择的索引配置
      titleArr: [{
        title: '锚点1'
      }, {
        title: '锚点2'
      }]
    };
  },
  computed: {
    isEmpty: function isEmpty() {
      try {
        return this.formData.data.titles.length;
      } catch (_unused) {
        return false;
      }
    },
    titles: function titles() {
      var _this = this;
      var arr = this.datas.titles.map(function (item) {
        return item.title[_this.cur];
      });
      this.titleArr = arr;
      return arr;
    },
    goodsList: function goodsList() {
      var list = this.$store.state.design.components.filter(function (item) {
        return item.name === 'Goodslist';
      });
      return list;
    }
  },
  methods: {
    handleClick: function handleClick(key, id) {
      this.showHead = false;
      this.active = key;
    }
  }
};